// extracted by mini-css-extract-plugin
export default {"cadastroPg":"styles_cadastroPg__+CQJf","formCadastro":"styles_formCadastro__e2nHT"};